import React from 'react';
interface Props {
  order: string;
  header: string;
  text: string;
}
const Bubble: React.FC<Props> = ({ order, header, text }) => {
  return (
    <div className={'flex justify-center flex-row  relative'}>
      <div className='text-[22px] md:text-[22px] font-[700] text-[#3D4257] absolute left-[-15%] top-[-3%] bg-[#E5E5E5] px-[10px] min-w-[35px] text-center rounded-[70rem]'>
        {order}
      </div>
      <div className='flex flex-col gap-3 '>
        <p className={'text-[18px] md:text-[22px] font-[700] text-[#484848]'}>
          {header}
        </p>
        <span className={'text-[16px] font-[400] max-w-[292px] text-[#484848]'}>
          {text}
        </span>
      </div>
    </div>
  );
};

export default Bubble;
